import type { IconSvgObject } from './types';

const EuroSquareIcon: IconSvgObject = [
  ["path", { d: "M21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 9.50024C15 8.50024 14.1936 8.00024 13.1056 8.00024C11.6665 8.00024 10.5 9.16679 10.5 10.6058V13.3947C10.5 14.8337 11.6665 16.0002 13.1056 16.0002C14.1936 16.0002 15 15.5002 15.5 14.5002M8.5 12.0002H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EuroSquareIcon;
